<template>
  <v-layout>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="9" md="7" lg="5">
          <v-card elevation="0">
            <v-card-title>Configuración de Ticket</v-card-title>
            <v-card-text v-if="!ticketSettings">
              <v-skeleton-loader type="paragraph" />
            </v-card-text>
            <v-card-text v-else>
              <v-checkbox
                label="Mostrar logo"
                v-model="ticketSettings.showLogo"
              ></v-checkbox>
              <single-image-uploader
                class="logo-container"
                v-if="ticketSettings.showLogo"
                v-model="ticketSettings.logoPath"
                preview-contain="fit"
                :max-width="512"
                :max-height="512"
              ></single-image-uploader>

              <v-checkbox
                label="Mostrar QR"
                v-model="ticketSettings.showQR"
              ></v-checkbox>

              <v-row>
                <v-col>
                  <h4>Tamaño Ticket</h4>
                  <v-select
                    v-model="ticketSettings.ticketSize"
                    :items="sizeText"
                  ></v-select>
                </v-col>
                <v-col>
                  <h4>Tamaño Comanda</h4>
                  <v-select
                    v-model="ticketSettings.comandaSize"
                    :items="sizeText"
                  ></v-select>
                </v-col>
              </v-row>

              <v-checkbox
                label="Mostrar dirección"
                v-model="ticketSettings.showAddress"
              ></v-checkbox>

              <v-checkbox
                :label="$t('ticketSettings.showCovers')"
                v-model="ticketSettings.showCovers"
              ></v-checkbox>

              <v-checkbox
                label="Mostrar texto al inicio"
                :input-value="ticketSettings.startText !== null"
                @change="
                  ticketSettings.startText === null
                    ? (ticketSettings.startText = '')
                    : (ticketSettings.startText = null)
                "
              ></v-checkbox>

              <v-textarea
                outlined
                dense
                :rows="2"
                v-model="ticketSettings.startText"
                v-if="ticketSettings.startText !== null"
                label="Texto"
                placeholder="Este texto se mostrará en el encabezado del ticket"
              ></v-textarea>

              <v-checkbox
                label="Mostrar texto al final"
                :input-value="ticketSettings.endText !== null"
                @change="
                  ticketSettings.endText === null
                    ? (ticketSettings.endText = '')
                    : (ticketSettings.endText = null)
                "
              ></v-checkbox>
              <v-textarea
                outlined
                dense
                :rows="2"
                v-model="ticketSettings.endText"
                v-if="ticketSettings.endText !== null"
                label="Texto"
                placeholder="Este texto se mostrará final del ticket"
              ></v-textarea>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                color="primary"
                :disabled="!valid"
                @click="save"
                :loading="loading"
                >{{ $t('save') }}</v-btn
              >
            </v-card-actions>
          </v-card>

          <v-divider class="my-4"></v-divider>

          <print-stations-card></print-stations-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import SingleImageUploader from '../SingleImageUploader.vue';
  import PrintStationsCard from '../partials/PrintStationsCard.vue';
  import ITicketSettings from '../../interfaces/ITicketSettings';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { IBranch } from '../../interfaces/IBranch';
  import BranchesService from '../../api/services/branches.service';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';

  @Component({
    components: { SingleImageUploader, PrintStationsCard },
  })
  export default class TicketSettings extends Vue {
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;

    branchesService = new BranchesService();

    ticketSettings: ITicketSettings = null;
    sizeText = [
      { value: 1, text: 'Normal' },
      { value: 2, text: 'Grande' },
    ];

    valid = true;
    loading = false;

    async created() {
      await this.loadTicketSettings();
    }

    async loadTicketSettings() {
      try {
        // defaultTicketSettings (showCovers: true included) is merged in by
        // the service, so every checkbox-bound key exists before assignment.
        this.ticketSettings = await this.branchesService.getTicketSettings(
          this.branch.id
        );
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      }
    }

    @Watch('branch')
    onBranchChanged() {
      this.loadTicketSettings();
    }

    async save() {
      this.loading = true;
      try {
        const settings = await this.branchesService.setTicketSettings(
          this.branch.id,
          this.ticketSettings
        );
        vueData.setTicketSettings(settings);
        vueData.addAlert('Configuración guardada', AlertType.Success);
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      } finally {
        this.loading = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .logo-container::v-deep .image .inner,
  .logo-container::v-deep .image .img {
    max-width: 100px;
    max-height: 100px;
  }
</style>
